export enum NewItemState {
	Barcode,
	Picture,
	Price
}
